/**
 * The words the holdings bar says (RFC 0297 §4d).
 *
 * Split from the component because this is the half that can be WRONG rather
 * than merely ugly: a miscount, a plural that reads as a bug, a relative time
 * that goes negative when two peers disagree about the clock. A component test
 * would have to mount a repo to reach any of it.
 */

import type { HeldDocument } from '@mod/core/model'

/**
 * "4m", "2h", "3d", from mod-core.
 *
 * ONE implementation, because the agent's block says "read 41m ago" about the
 * same holding this row does, and two sessions told different ages by the two
 * renderers is §4d's invariant broken in the place it is hardest to notice.
 */
export { ago } from '@mod/core/model'

/**
 * The resting line: how many, and whether any of it needs you.
 *
 * A SINGLE HOLDING SHOWS AS ITSELF. "1 in hand" tells you less than the name
 * does, and the name is what you would otherwise have to open the bar to find.
 *
 * Nothing else is said when nothing has happened. The bar has to be boring in
 * the common case or the amber dot means nothing.
 */
export function summary(rows: HeldDocument[]): string {
  const changed = rows.filter((r) => r.changed).length
  const comments = rows.reduce((n, r) => n + r.newComments, 0)
  const head = rows.length === 1 ? rows[0].title : `${rows.length} in hand`
  const rest = [
    changed > 0 ? `${changed} changed` : null,
    comments > 0 ? `${comments} waiting on you` : null,
  ].filter(Boolean)
  return rest.length > 0 ? `${head} · ${rest.join(' · ')}` : head
}
